export const KOREAN_TIME_OFFSET = 9 * 60;
